import { TransportMethod } from "@domain/shipment/models/TransportMethod";
import { Badge, Box, useTheme } from "@mui/material";
import { Icon } from "@shared/icons";
import { IconSize } from "@shared/icons/Icon";



export const TransportMethodIcon = ({ transportMethod, size = 30, badge }: { transportMethod?: TransportMethod, size?: number, badge?: string }) => {

    const theme = useTheme();

    const getTransportMethodIconUrl = (transportMethod?: TransportMethod) => {
        switch (transportMethod) {
            case TransportMethod.BOAT:
                return 'Boat';
            case TransportMethod.TRUCK:
                return 'Truck';
            case TransportMethod.TRAIN:
                return 'Train';
            case TransportMethod.PLANE:
                return 'Plane';
            default:
                return 'Truck';
        }
    }

    return (
        <Box
            width={size}
            height={size}
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{
                border: `1px solid ${theme.palette.divider}`,
                borderRadius: 1,
                boxSizing: 'border-box',
            }}
        >
            <Icon icon={getTransportMethodIconUrl(transportMethod)} size={IconSize.LARGE} />
            {badge && (
                <Badge
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    color="primary"
                    badgeContent={badge}
                />
            )}
        </Box>
    )
};
